"use client";

import SectionHeading from "../shared/SectionHeading";

// import learning from "../../assetscourse-details/learnings.png";

const Learnings = ({ data }) => {

  const IMAGE_BASE = process.env.REACT_APP_IMAGE_URL;

  if (!data.section[1].isActive) {
    return <div></div>;
  }

  return (
    <div
      className="px-[90px] py-14 mt-14"
      style={{ background: "linear-gradient(90deg, rgba(255, 153, 0, 0.05) 0%, rgba(4, 35, 107, 0.05) 100%)"}}
    >
      {/* <h1 className="text-center text-primary-color text-[40px] font-medium	">
        What will <span className="text-secondary-color">you Learn?</span>
      </h1> */}
      <SectionHeading>
          <span className="text-primary-color">What will</span>{" "}
          <span className="text-secondary-color">you Learn</span>
        </SectionHeading>
      <img
        src={`${IMAGE_BASE}/program/what-will-you-learn/${data.programId}.png`}
        alt=""
        className="mt-10 mx-auto"
      />
    </div>
  );
};

export default Learnings;
